import React, { useEffect, useState } from "react";
import { Download, X } from "lucide-react";

const DISMISSED_KEY = "reflecta.pwa.installDismissed";

const InstallPrompt = ({ enabled = true }) => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (window.localStorage.getItem(DISMISSED_KEY) === "1") {
      return undefined;
    }

    const handleBeforeInstallPrompt = (event) => {
      event.preventDefault();
      setDeferredPrompt(event);
      if (enabled) {
        setVisible(true);
      }
    };

    window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
    return () => window.removeEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
  }, [enabled]);

  useEffect(() => {
    if (!enabled) {
      setVisible(false);
      return;
    }

    if (deferredPrompt && window.localStorage.getItem(DISMISSED_KEY) !== "1") {
      setVisible(true);
    }
  }, [deferredPrompt, enabled]);

  if (!enabled || !visible || !deferredPrompt) {
    return null;
  }

  const handleInstall = async () => {
    deferredPrompt.prompt();
    await deferredPrompt.userChoice;
    setVisible(false);
    setDeferredPrompt(null);
  };

  const handleDismiss = () => {
    window.localStorage.setItem(DISMISSED_KEY, "1");
    setVisible(false);
  };

  return (
    <div className="fixed bottom-6 left-1/2 z-[60] w-[calc(100%-2rem)] max-w-md -translate-x-1/2 rounded-2xl border border-gray-100 bg-white p-4 shadow-2xl">
      <button
        type="button"
        onClick={handleDismiss}
        className="absolute right-3 top-3 rounded-full p-1 text-gray-400 hover:bg-gray-100 hover:text-gray-600"
        aria-label="Dismiss install prompt"
      >
        <X className="h-4 w-4" />
      </button>
      <div className="pr-8">
        <h2 className="text-sm font-semibold text-gray-900">Install Reflecta</h2>
        <p className="mt-1 text-sm text-gray-500">Open Reflecta faster from your home screen.</p>
      </div>
      <button
        type="button"
        onClick={handleInstall}
        className="mt-4 inline-flex items-center gap-2 rounded-full bg-gradient-to-r from-[#9B30FF] to-[#6A0DAD] px-4 py-2 text-sm font-semibold text-white"
      >
        <Download className="h-4 w-4" />
        Install
      </button>
    </div>
  );
};

export default InstallPrompt;
